<template>
  <modal-slots 
    :showMod="isShowModal"
    :isBorder="false"
    @close="$emit('on-close')"
    @apply="$emit('on-send')"
  >
    <template v-slot:title>
      <h2 class="fz18 fw500" v-if="$route.name != 'port-archive-contacts'">Archive the contact</h2>
      <h2 class="fz18 fw500" v-else>Unarchive the contact</h2>
    </template>

    <p class="p-6 fz14" v-if="$route.name != 'port-archive-contacts'">Are you sure you want to archive this contact?</p>
    <p class="p-6 fz14" v-else>Are you sure you want to unarchive this contact?</p>

    <template v-slot:bottomFirstButton>
      <button class="blue-button-text fz14 fw500 m-l-6 p-x-16" @click="$emit('on-close')">No</button>
    </template>
    <template v-slot:bottomSecondButton>
      <button class="blue-button fz14 fw500 m-l-6 p-x-16" @click="$emit('on-send')">Yes</button>
    </template>
  </modal-slots>
</template>

<script>
import modalSlots from '@/components/modal/modal-slots'

export default {
  components: {
    modalSlots
  },
  props: {
    isShowModal: Boolean,
    berth: Object
  }
}
</script>

<style>

</style>